import types from './types';

const defaultState = {
  batchUpdatePossibleFieldsList: [],
  isContactOverrideMode: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE:
      return {
        ...state,
        isLoading: true
      };
    case types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_SUCCESS:
      return {
        ...state,
        batchUpdatePossibleFieldsList: data,
        isLoading: false
      };
    case types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE_FAILURE:
      return {
        ...state,
        isLoading: false
      };
    case types.SET_IS_CONTACT_OVERRIDE_MODE: 
      return {
        ...state, 
        isContactOverrideMode: action.isContactOverrideMode
      }
    case types.SET_IS_CONTACT_OVERRIDE_MODE: 
      return {
        ...state, 
        isContactOverrideMode: action.isContactOverrideMode
      }
    default:
      return state;
  }
};
